import React from 'react';
import { Stack } from '@mui/material';
import { ProgressBar } from 'components/shared';
import FeatureFlagsContext from '../FeatureFlagsContext';

export default function PageLayout({ currentSection, children }) {
  const featureFlags = React.useContext(FeatureFlagsContext);

  const progressBarSections = [
    { name: 'accountType', label: 'ACCOUNT TYPE' },
    { name: 'practiceInfo', label: 'PRACTICE INFO' },
    { name: 'clinicPersonnel', label: 'CLINIC PERSONNEL' },
    { name: 'signature', label: 'SIGNATURE' },
  ];

  return (
    <Stack
      spacing={5.5}
      sx={{
        paddingRight: '2.75rem',
        paddingLeft: '2.75rem',
        alignItems: 'center',
        maxWidth: '82.5rem',
      }}
    >
      <ProgressBar
        headerText="Veterinary Resellers Agreement"
        currentSection={currentSection}
        sections={progressBarSections}
      />
      {children}
    </Stack>
  );
}
